import { StringSchema } from 'yup'
import { phone } from './utils'

const phoneValidator = function (this: StringSchema, message = 'Número de telefone inválido.') {
  return this.test('phone', message, function (value: string | undefined) {
    const { path, createError } = this
    const saoPauloDDD = '11'

    const {
      cleanedPhone,
      phoneWithoutDDD,
      phoneDDD,
      isTollFreePhone,
      isLocalPhone,
      isMobilePhone,
      isMobilePhoneSaoPaulo,
    } = phone(value)

    if (!cleanedPhone) {
      return createError({ path, message: 'O telefone é um campo obrigatório' })
    }

    const isPhoneValid =
      (cleanedPhone.length === 10 && isLocalPhone) ||
      (cleanedPhone.length === 11 && (isTollFreePhone || (isMobilePhone && phoneWithoutDDD[0] === '9'))) ||
      (phoneDDD === saoPauloDDD && isMobilePhoneSaoPaulo)

    if (!isPhoneValid) {
      return createError({ path, message })
    }

    return true
  })
}

export default phoneValidator
